import React from 'react';
import PropTypes from 'prop-types';
import { Card, Page } from '../../../components';
import CarrierForm from './CarrierForm';

const propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      carrierId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default function EditCarrier({ match }) {
  const { params: { carrierId } } = match;

  return (
    <Page
      breadcrumbs={[{ content: 'View Carrier Details', href: `/settings/carriers/${carrierId}` }]}
      title="Edit Carrier"
    >
      <Card>
        <Card.Block>
          <CarrierForm carrierId={carrierId} />
        </Card.Block>
      </Card>
    </Page>
  );
}


EditCarrier.propTypes = propTypes;
